import { render, staticRenderFns } from "./EditRecordDialog.vue?vue&type=template&id=9f1ba436&"
import script from "./EditRecordDialog.vue?vue&type=script&lang=js&"
export * from "./EditRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports